import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Página pública que o QR code do certificado do INEP abre: /validar/<código>.
// Mostra se o certificado é válido e os dados dele, com o CPF mascarado.
const C = {
  fundo: { minHeight: '100vh', background: '#f2f6fb', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif', color: '#10233b' },
  card: { width: '100%', maxWidth: 560, background: '#fff', borderRadius: 18, boxShadow: '0 20px 40px -18px rgba(10,37,64,.3)', overflow: 'hidden' },
  topo: ok => ({ padding: '22px 26px', color: '#fff', background: ok ? 'linear-gradient(135deg,#0f8f61,#1cbf82)' : 'linear-gradient(135deg,#b4232c,#e14d38)' }),
  linha: { display: 'flex', justifyContent: 'space-between', gap: 16, padding: '11px 0', borderBottom: '1px solid #eef2f6', fontSize: 14.5 },
  rot: { color: '#5f7288' },
};

export default function ValidarCertificado() {
  const { cod } = useParams();
  const [r, setR] = useState(null);
  useEffect(() => {
    fetch(`/api/validar-certificado?cod=${encodeURIComponent(cod || '')}`)
      .then(x => x.json()).then(setR).catch(() => setR({ valido: false, error: 'Não foi possível consultar agora. Tente de novo em instantes.' }));
  }, [cod]);

  if (!r) return <div style={C.fundo}><div style={{ color: '#5f7288' }}>Consultando certificado…</div></div>;
  const ok = !!r.valido;
  const campos = ok ? [
    ['Aluno', r.aluno], ['CPF', r.cpf], ['Curso', r.curso],
    ['Período', r.inicio && r.fim ? `${r.inicio} a ${r.fim}` : ''], ['Carga horária', r.cargaHoraria],
    ['Emitido em', r.emitidoEm], ['Código', r.codigo],
  ].filter(([, v]) => v) : [];
  return (
    <div style={C.fundo}>
      <div style={C.card}>
        <div style={C.topo(ok)}>
          <div style={{ fontSize: 13, opacity: 0.9, fontWeight: 600, letterSpacing: '.04em' }}>VALIDAÇÃO DE CERTIFICADO</div>
          <div style={{ fontSize: 24, fontWeight: 800, marginTop: 4 }}>{ok ? '✅ Certificado válido' : r.cancelado ? '⛔ Certificado cancelado' : '❌ Certificado não encontrado'}</div>
        </div>
        <div style={{ padding: '10px 26px 22px' }}>
          {ok ? campos.map(([k, v]) => (
            <div key={k} style={C.linha}><span style={C.rot}>{k}</span><b style={{ textAlign: 'right' }}>{v}</b></div>
          )) : (
            <p style={{ fontSize: 14.5, color: '#5f7288', lineHeight: 1.6 }}>
              {r.error || <>Não existe certificado emitido com o código <b>{(cod || '').toUpperCase()}</b>. Confira se o código foi digitado corretamente.</>}
            </p>
          )}
          <p style={{ fontSize: 12.5, color: '#94a3b8', marginTop: 18, marginBottom: 0 }}>{r.instituicao || 'INEP – Instituto de Educação e Pesquisa do Prontobaby'}</p>
        </div>
      </div>
    </div>
  );
}
